exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-range div {\n    background-color: #F2F2F2;\n}\n.date-select {\n    max-width: 100px;\n}\n.date-range button {\n    max-width: 40px;\n    min-width: 20px;\n}\n\n\n", ""]);

// exports
